import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const styles = tv({
    slots: {
        container: `
      iris:w-fit
    `,
        header: `
      iris:flex
      iris:justify-between
      iris:gap-x-(--base-space-px-24)
      iris:pl-(--base-space-px-12)
    `,
        headerDate: `
      iris:flex
      iris:items-center
      iris:font-(family-name:--comp-type-font-calendar-title)
      iris:text-(length:--comp-type-size-calendar-title)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-calendar-title)!
    `,
        headerControlContainer: `
      iris:flex
    `,
        headerControlItem: `
      iris:flex
      iris:size-(--comp-size-box-calendar-items)
      iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:rounded-(--comp-size-radius-calendar)
      iris:transition-all
      iris:duration-(--comp-motion-duration-calendar)
      iris:ease-(--comp-motion-easing-calendar)
      iris:disabled:pointer-events-none
      iris:disabled:cursor-not-allowed
      iris:disabled:opacity-(--sem-opacity-interactive-disabled)
    `,
        headerControlItemIcon: `
      iris:size-(--comp-size-icon-calendar)
    `,
        contentRow: `
      iris:flex
    `,
        content: `
    `,
        contentHeader: `
      iris:flex
      iris:size-(--comp-size-box-calendar-items)
      iris:items-center
      iris:justify-center
      iris:rounded-full
      iris:font-(family-name:--comp-type-font-calendar-header)
      iris:text-(length:--comp-type-size-calendar-header)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-calendar-header)!
    `,
        contentItem: `
      iris:flex
      iris:size-(--comp-size-box-calendar-items)
      iris:cursor-pointer
      iris:items-center
      iris:justify-center
      iris:rounded-full
      iris:px-(--comp-space-padding-calendar-horizontal)

      iris:font-(family-name:--comp-type-font-calendar-day)
      iris:text-(length:--comp-type-size-calendar-day)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-calendar-day)!

      iris:transition-all
      iris:duration-(--comp-motion-duration-calendar)
      iris:ease-(--comp-motion-easing-calendar)
      iris:data-[state=current]:border
      iris:data-[state=current]:border-solid
      iris:data-[state=current-selected]:border
      iris:data-[state=current-selected]:border-solid
      iris:data-[state=current-selected]:leading-(--base-typography-leading-normal)
      iris:data-[state=selected]:leading-(--base-typography-leading-tight)
      iris:data-[status=active-disabled]:pointer-events-none!
      iris:data-[status=active-disabled]:cursor-not-allowed!

      iris:data-[status=disabled]:pointer-events-none
      iris:data-[status=disabled]:cursor-not-allowed
      iris:data-[status=disabled]:opacity-(--sem-opacity-interactive-disabled)
    `,
    },
    variants: {
        inverse: {
            false: {
                headerDate: `
          iris:text-(--comp-color-content-calendar-title)
        `,
                headerControlItem: `
          iris:bg-(--comp-color-background-calendar-button-rest)
          iris:text-(--comp-color-content-calendar-button)
          iris:hover:bg-(--comp-color-background-calendar-button-hover)
          iris:active:bg-(--comp-color-background-calendar-button-pressed)
          ${focusStyles.default}

        `,
                contentHeader: `
          iris:text-(--comp-color-content-calendar-header)
        `,
                contentItem: `
          iris:bg-(--comp-color-background-calendar-day-rest)
          iris:text-(--comp-color-content-calendar-day)
          iris:hover:bg-(--comp-color-background-calendar-day-hover)
          iris:active:bg-(--comp-color-background-calendar-day-pressed)
          ${focusStyles.default}

          iris:data-[state=current]:border-(--comp-color-border-calendar-current-day)
          iris:data-[state=current]:bg-(--comp-color-background-calendar-current-day-rest)
          iris:data-[state=current]:hover:bg-(--comp-color-background-calendar-current-day-hover)
          iris:data-[state=current]:active:bg-(--comp-color-background-calendar-current-day-pressed)
          iris:data-[state=current-selected]:border-(--comp-color-border-calendar-current-day)
          iris:data-[state=current-selected]:bg-(--comp-color-background-calendar-current-day-selected)
          iris:data-[state=current-selected]:text-(--comp-color-content-calendar-day-selected)
          iris:data-[state=current-selected]:hover:bg-(--comp-color-background-calendar-current-day-selected)
          iris:data-[state=current-selected]:active:bg-(--comp-color-background-calendar-current-day-selected)
          iris:data-[state=selected]:bg-(--comp-color-background-calendar-day-selected)
          iris:data-[state=selected]:text-(--comp-color-content-calendar-day-selected)
          iris:data-[state=selected]:hover:bg-(--comp-color-background-calendar-day-selected)
          iris:data-[state=selected]:active:bg-(--comp-color-background-calendar-day-selected)
        `,
            },
            true: {
                headerDate: `
          iris:text-(--comp-color-content-calendar-title-inverse)
        `,
                headerControlItem: `
          iris:bg-(--comp-color-background-calendar-button-inverse-rest)
          iris:text-(--comp-color-content-calendar-button-inverse)
          iris:hover:bg-(--comp-color-background-calendar-button-inverse-hover)
          iris:active:bg-(--comp-color-background-calendar-button-inverse-pressed)
          ${focusStyles.inverse}

        `,
                contentHeader: `
          iris:text-(--comp-color-content-calendar-header-inverse)
        `,
                contentItem: `
          iris:bg-(--comp-color-background-calendar-day-inverse-rest)
          iris:text-(--comp-color-content-calendar-day-inverse)
          iris:hover:bg-(--comp-color-background-calendar-day-inverse-hover)
          iris:active:bg-(--comp-color-background-calendar-day-inverse-pressed)
          ${focusStyles.inverse}

          iris:data-[state=current]:border-(--comp-color-border-calendar-current-day-inverse)
          iris:data-[state=current]:bg-(--comp-color-background-calendar-current-day-inverse-rest)
          iris:data-[state=current]:hover:bg-(--comp-color-background-calendar-current-day-inverse-hover)
          iris:data-[state=current]:active:bg-(--comp-color-background-calendar-current-day-inverse-pressed)
          iris:data-[state=current-selected]:border-(--comp-color-border-calendar-current-day-inverse)
          iris:data-[state=current-selected]:bg-(--comp-color-background-calendar-current-day-inverse-selected)
          iris:data-[state=current-selected]:text-(--comp-color-content-calendar-day-inverse-selected)
          iris:data-[state=current-selected]:hover:bg-(--comp-color-background-calendar-current-day-inverse-selected)
          iris:data-[state=current-selected]:active:bg-(--comp-color-background-calendar-current-day-inverse-selected)
          iris:data-[state=selected]:bg-(--comp-color-background-calendar-day-inverse-selected)
          iris:data-[state=selected]:text-(--comp-color-content-calendar-day-inverse-selected)
          iris:data-[state=selected]:hover:bg-(--comp-color-background-calendar-day-inverse-selected)
          iris:data-[state=selected]:active:bg-(--comp-color-background-calendar-day-inverse-selected)
        `,
            },
        },
    },
});

export { styles as default };
